import PadraoModel from 'src/core/model/PadraoModel.js'

export default class OlxCombustivelModel extends PadraoModel {
  recurso = 'olx/combustiveis';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Combustíveis Olx';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
